// HUD panel ids and stage-card `open` ids → the live page for that aspect.
// Identity, mail, invoices and dev access stay in the drawer.

export const APP_ASPECT = {
  'ap-health': 'health',
  'ap-services': 'services',
  'ap-eco': 'services',
  'ap-security': 'security',
  'ap-envs': 'environments',
  'ap-traffic': 'traffic',
  'ap-anomalies': 'anomalies',
  'ap-costs': 'costs',
  'ap-usage': 'usage',
};

export const ORG_ASPECT = {
  scans: 'security',
  traffic: 'traffic',
  anomalies: 'anomalies',
};

export const FLEET_ASPECT = {
  scans: 'security',
  incidents: 'incidents',
  hosts: 'hosts',
  traffic: 'traffic',
  anomalies: 'anomalies',
  standby: 'standby',
  release: 'release',
  plane: 'plane',
};

export const appLive = (orgId, appId, aspect) => `/orgs/${orgId}/apps/${appId}/live/${aspect}`;
export const orgLive = (orgId, aspect) => `/orgs/${orgId}/live/${aspect}`;
export const fleetLive = (aspect) => `/admin/fleet/${aspect}`;

export const APP_LIVE = ['security', 'health', 'services', 'traffic', 'anomalies', 'environments', 'usage', 'costs'];
export const ORG_LIVE = ['security', 'traffic', 'anomalies'];
export const FLEET_LIVE = ['security', 'incidents', 'hosts', 'traffic', 'anomalies', 'standby', 'release', 'plane'];
